<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_step3_rates.svg`)"
            imageLabel="Rates & Fees"
            heading="How much is your refundable security deposit?"
            :step="8"
        >

            <div class="ph3 ph4-ns">
                <CurrencyInput v-model="deposit" class="w-inherit"/>
                
                <info class="w-100 w-75-ns w-60-m" title="How are security deposits handled?">
                    <div class="mt1 mb2">All security deposits are paid through Tooliaba. An owner can request some or all of the security deposit within 14 days of a rental or before a new rental, whichever happens first.</div>
                    <div class="mb2">Security deposits are collected and held with payment. An owner will need to reach out to our support center to send documentation of the damages (like photos or receipts), and request money from their renter to fix those damages.</div>
                    <div><b>Note: </b>All payments, including security deposits, are made through Tooliaba. Don't ever exchange money with an owner or renter of this Tooliaba web app.</div>
                </Info>
            </div>

        </ListContainer>

        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" forward="Next" @backClick="$router.push('/rates')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import CurrencyInput from '@/components/controls/CurrencyInput.vue';
import Info from '@/components/list/shared/Info.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import { mapMutations } from 'vuex';

export default {
    data() {
        return {
            deposit: 0
        };
    },
    components: {
        ShadowBoxContainer,
        ListContainer,
        CurrencyInput,
        Info,
        NavigationButtons
    },
    methods: {
        ...mapMutations('newListing', ['setDeposit']),
        next() {
            this.setDeposit(this.deposit);
            this.$router.push('/additional-fees');
        }
    }
};
</script>
